import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  CBadge,
  CCard,
  CCardBody,
  CButton,
  CCardHeader,
  CCol,
  CDataTable,
  CRow, CImage,
  CPagination,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CForm, CCardFooter,
  CFormText, CDropdown,
  CFormLabel, CCardTitle,
  CFormInput, CFormInputGroup, CFormInputGroupText
} from 'compat/coreui'

import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';



const SearchDeals = (props) => {
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [discount, setDiscount] = useState("");
  const [discountType, setDiscountType] = useState("");
  const [dealsData, setDealsData] = useState([])
  const token = localStorage.getItem('token');



  const toggle = () => {
    setModal(!modal);
  }

  useEffect(async () => {
    getDeals()
  }, [])



  const getDeals = () => {
    axios({
      url: `${process.env.REACT_APP_APP_API_URL}/api/dealall`,
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then(response => {
      if (response.data.status) {
        setDealsData(response.data.deals);
      }
    }).catch(console.log)
  }


  const addDeals = (e) => {
    e.preventDefault()
    const data = {
      "description": description,
      "title": title,
      "category": category,
      "type": type,
      "discount": discount,
      "discountType": discountType,
    }
    axios({
      url: `${process.env.REACT_APP_APP_API_URL}/api/deal`,
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + token
      },
      data
    }).then(response => {
      if (response.data.status) {
        setModal(!modal);
        toast.success('Deal added successfully')
      }
    }).catch(console.log)
  }


  return (
    <React.Fragment>
      <CRow style={{ marginTop: "10px" }}>
        <CCol lg={9} className="mt-5">
          {dealsData.length > 0 && dealsData.map((dealItem, i) => {
            return (<CCol lg={4} key={i}>
              <CCard className="deal-page-card">
                <CCardHeader className="p-0 b-header">
                  <CImage src="/images/jack.png" width="100%"></CImage>
                </CCardHeader>
                <CCardBody className="text-center">
                  <CCardTitle>
                    <p>{dealItem.title}</p>
                  </CCardTitle>
                </CCardBody>
                <CCardFooter className="biz-deal deals-footer">
                  <span>Flower</span><span>Both</span><span>2096</span>
                </CCardFooter>
              </CCard>
            </CCol>)
          })}
        </CCol>
      </CRow>
      <CModal
        show={modal}
        onClose={toggle}
      >
        <CModalHeader closeButton className="text-white" style={{ background: "#FF5F1F" }}>Add A Deal</CModalHeader>
        <CModalBody>
          <CCardTitle>
            Add Details
                </CCardTitle>
          <form>
            <CForm className="d-flex">
              <CCol xl={3} className="pr-0">
                <CFormLabel htmlFor="nf-title">Pricing</CFormLabel>
                <CDropdown className="btn-lg" style={{ padding: '0px' }}>
                  <select className="custom-select my-1 mr-sm-2 product_status" name="discountType" onChange={(e) => setDiscountType(e.target.value)}>
                    <option value={`2`}>%</option>
                    <option value={`1`}>$</option>
                    <option value={`3`}>BOGO</option>
                  </select>
                </CDropdown>
              </CCol>
              <CCol xl={2} className="pr-0">
                <CFormLabel htmlFor="nf-title" className="pb-1">&nbsp;</CFormLabel>
                <CFormInput type="text" placeholder="0" name="discount" onChange={(e) => setDiscount(e.target.value)} />
              </CCol>
              <CCol xl={7} className="pr-0">
                <CFormLabel htmlFor="nf-title" className="pb-1">Title</CFormLabel>
                <CFormInput type="text" placeholder="eg. Grams of Wax" name="title" onChange={(e) => setTitle(e.target.value)} />
              </CCol>
            </CForm>

            <CForm className="d-flex">
              <CCol className="pr-0">
                <CFormLabel htmlFor="nf-title" className="pb-1">Description(optional)</CFormLabel>
                <CFormInput type="textarea" placeholder="eg. Grams of Wax" name="description" onChange={(e) => setDescription(e.target.value)} />
              </CCol>
            </CForm>
            <CForm className="d-flex">
              <CCol className="pr-0">
                <CFormLabel htmlFor="nf-title" className="pb-1">Image</CFormLabel><br />
                <div className="fileUpload btn btn-primary">
                  <span>Select File</span>
                  <input type="file" className="upload" />
                </div>
              </CCol>
              <CCol>
                <CFormLabel htmlFor="nf-title">Type</CFormLabel>
                <CDropdown className="btn-lg" style={{ padding: '0px' }}>
                  <select className="custom-select my-1 mr-sm-2 product_status" name="type" onChange={(e) => setType(e.target.value)}>
                    <option value={`Medical`}>Medical</option>
                    <option value={`Recreational`}>Recreational</option>
                    <option value={`Both`}>Both</option>
                  </select>
                </CDropdown>

                <CFormLabel htmlFor="nf-title">Category</CFormLabel>
                <CDropdown className="btn-lg" style={{ padding: '0px' }}>
                  <select className="custom-select my-1 mr-sm-2 product_status" name="category" onChange={(e) => setCategory(e.target.value)}>
                    <option value="bud">Flower</option>
                    <option value="concentrates">Concentrates</option>
                    <option value="edibles">Edibles</option>
                    <option value="seeds">Seeds</option>
                    <option value="prerolls">Prerolls</option>
                    <option value="vaporizers">Vaporizers</option>
                    <option value="other">Other</option>
                  </select>
                </CDropdown>
                {/*<div className="apply_type">
                           <CFormLabel htmlFor="nf-title" className="apply_type">Check any that apply</CFormLabel>
                           <span><CFormInput type="checkbox" className="category-checkbox"/> Gram Deal</span>
                           <span><CFormInput type="checkbox" className="category-checkbox"/> 1/8th Deal</span>
                           <span><CFormInput type="checkbox" className="category-checkbox"/> Ounce Deal</span>
                           <span><CFormInput type="checkbox" className="category-checkbox"/> High CBD</span>
                         </div>*/}
              </CCol>
            </CForm>
            <CCol className="mt-5">
              <CButton color="success" type="submit" onClick={addDeals}>POST DEAL</CButton>{' '}
              <CButton
                color="secondary"
                className="pl-4 pr-4"
                onClick={toggle}>
                Cancel
                      </CButton>
            </CCol>
          </form>
        </CModalBody>
      </CModal>
    </React.Fragment>
  )
}

export default SearchDeals;
